import {Ingredient} from "./ingredient";

export class RecipePart {

  id: string;
  duration: number;
  name: string;
  description: string;
  ingredients: Ingredient[];
  steps: string[];

  constructor(obj: {
    id?: string,
    duration?: number,
    name?: string,
    description?: string,
    ingredients?: Ingredient[],
    steps?: string[]
  }) {
    this.id = obj.id || null;
    this.duration = obj.duration || 15;
    this.name = obj.name || "";
    this.description = obj.description || "";
    this.ingredients = [];
    if (obj.ingredients)
      obj.ingredients.forEach(ingredient => this.ingredients.push(new Ingredient(ingredient)));
    this.steps = [];
    if (obj.steps)
      obj.steps.forEach(step => this.steps.push(step))
  }

}


